import { Column, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { SolidExclamationWarningAlertIcon } from '@tempmee/react-icons';

interface IInfoSectionProps {
  title: string;
  value: string | number | undefined;
  showWarningIcon?: boolean;
}

export const InfoSection = ({ title, value, showWarningIcon = false }: IInfoSectionProps) => (
  <Column gap={1}>
    <Row align="center" gap={2}>
      <Typography as="span" bold size="heading_4">
        {title}:
      </Typography>
      {showWarningIcon && <SolidExclamationWarningAlertIcon color={colors.warning[500]} size={18} />}
    </Row>
    <Typography as="span">{value}</Typography>
  </Column>
);
